module.exports = __webpack_public_path__ + "static/media/pdf.117d3506.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf.svg
// module id = 587
// module chunks = 0